/**
 * @generated SignedSource<<4fc5ca184f24b4ab5e63b2ba24af3b65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ClassCategory = "HIDDEN" | "ICON" | "%future added value";
export type SetClassCategoryInput = {
  category: ClassCategory;
  classId: string;
  value?: string | null | undefined;
};
export type ClassCategoriesSetClassCategoryMutation$variables = {
  input: SetClassCategoryInput;
};
export type ClassCategoriesSetClassCategoryMutation$data = {
  readonly setClassCategory: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly userClassCategoryNode: {
      readonly category: ClassCategory;
      readonly classId: string;
      readonly id: string;
      readonly value: string | null | undefined;
    } | null | undefined;
  };
};
export type ClassCategoriesSetClassCategoryMutation = {
  response: ClassCategoriesSetClassCategoryMutation$data;
  variables: ClassCategoriesSetClassCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetClassCategoryPayload",
    "kind": "LinkedField",
    "name": "setClassCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserClassCategoryNode",
        "kind": "LinkedField",
        "name": "userClassCategoryNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "classId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassCategoriesSetClassCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassCategoriesSetClassCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "deea60404498f51fea9b25a4a80d5dce",
    "id": null,
    "metadata": {},
    "name": "ClassCategoriesSetClassCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation ClassCategoriesSetClassCategoryMutation(\n  $input: SetClassCategoryInput!\n) {\n  setClassCategory(input: $input) {\n    userClassCategoryNode {\n      id\n      classId\n      category\n      value\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c00d898e513f6ab00cf6487267da818b";

export default node;
